import $ from 'jquery'
import { numberWithCommas } from "./custom_format_input_number.js";

$(document).on('turbolinks:load', function () {
  calculate_order_item_total_price();

  $('.js-source-clients-shop').on('select2:select', function (e) {
    const clientId = e.params.data.id;

    $.ajax({
      url: `/clients/${clientId}/payment_type`,
      method: 'GET',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).done(function (data) {
      const $taxArea = $('.js-display-consumption-tax-area');
      const $checkbox = $('#shop_display_consumption_tax');

      if (data.payment_type === 'credit') {
        $taxArea.removeClass('d-none');
      } else {
        $taxArea.addClass('d-none');
        $checkbox.prop('checked', false);
      }
    });
  });

  $(".shop-products-sortable").sortable({
    items: ".product-item:not(.unsortable)",
    update: function (event, ui) {
      let sortable_wrapper = ui.item.parents('.shop-products-sortable');
      let items = sortable_wrapper.find('.product-item:not([style*="display: none"])');

      for (let i = 0; i < items.length; i++) {
        let item_index = i + 1;

        $(items[i]).find('input.js-sort-index-val').val(item_index);
      }
    }
  });

  let checked_shop = localStorage.getItem("checked_shop");

  if (checked_shop) {
    $('input.js-checked-shop-ids').val(checked_shop);
    let checked_shop_ids = checked_shop.split(",");
    var is_checked_all = true;
    var checked_shops = $('input[name=checkbox-shop]');

    for (let i = 0; i < checked_shops.length; i++) {
      let shop_id = $(checked_shops[i]).val();
      if (checked_shop_ids.includes(shop_id)) {
        $(checked_shops[i]).prop('checked', true);
      } else {
        if (shop_id != 'check_all') {
          is_checked_all = false;
        }
      }
    }

    if (is_checked_all) {
      $('.row.row-head input[name=checkbox-shop]').prop('checked', true);
    }
  }

  $('.js-checkbox-shop').change(function () {
    var is_checked_all = false;

    if (this.checked) {
      if ($(this).val() == "check_all") {
        var checked_shops = $('input[name=checkbox-shop]');
        for (let i = 0; i < checked_shops.length; i++) {
          $(checked_shops[i]).prop('checked', true);
        }

        getAndStoreSearchedShops();
      } else {
        var current_shop_id = $(this).val();
        var shop_ids_storage = localStorage.getItem("checked_shop");
        var arr_shop_ids_storage = [];

        if (shop_ids_storage != 'check_all') {
          if (shop_ids_storage) {
            arr_shop_ids_storage = shop_ids_storage.split(",");
          }
          arr_shop_ids_storage.push(current_shop_id);
          localStorage.setItem("checked_shop", arr_shop_ids_storage.join(","));
        }
      }
    } else {
      if ($(this).val() == "check_all") {
        is_checked_all = false;
        localStorage.setItem("checked_shop", "");

        var checked_shops = $('input[name=checkbox-shop]');
        for (let i = 0; i < checked_shops.length; i++) {
          $(checked_shops[i]).prop('checked', false);
        }
      } else {
        var current_shop_id = $(this).val();
        var shop_ids_storage = localStorage.getItem("checked_shop");

        if (shop_ids_storage != 'check_all') {
          var arr_shop_ids_storage = shop_ids_storage.split(",");
          let index = arr_shop_ids_storage.indexOf(current_shop_id);

          if (index > -1) { // only splice array when item is found
            arr_shop_ids_storage.splice(index, 1); // 2nd parameter means remove one item only
          }

          localStorage.setItem("checked_shop", arr_shop_ids_storage.join(","));
        }
      }
    }

    if (is_checked_all) {
      $('input.js-checked-shop-ids').val('check_all');
      localStorage.setItem("checked_shop", "check_all");
    } else {
      var shop_ids_storage = localStorage.getItem("checked_shop");

      $('input.js-checked-shop-ids').val(shop_ids_storage);
    }
  });

  $('#shop-products')
    .on('cocoon:after-insert', function (e, added_item) {
      added_item.after($('#js-link-to-add-item'));

      let sortable_wrapper = $(added_item).parents('.shop-products-sortable');
      let items = sortable_wrapper.find('.product-item:not([style*="display: none"])');

      let added_item_index = items.length;

      $(added_item).find('input.js-sort-index-val').val(added_item_index);
    });

  // admin email 
  $('#admin_emails-nested-form .content-nested-form')
    .on('cocoon:after-insert', function (e, added_item) {
      setTimeout(() => {
        added_item.after($('#js-link-to-add-item'));
        updateSortIndex();
    
        const newInput = $(added_item).find('input[type="text"]').first();
        if (newInput.length) {
          moveCursorToEnd(newInput.get(0));
        }
      }, 0);
    }).on('cocoon:after-remove', function () {
      updateSortIndex();
    });

  $(".admin-email-sortable").sortable({
    items: ".admin-email-item:not(.unsortable)",
    update: function () {
      updateSortIndex();
    }
  });

  function updateSortIndex() {
    let items = $(".admin-email-sortable .admin-email-item:not([style*='display: none'])");

    items.each(function (index) {
      $(this).find('input.js-sort-index-val').val(index + 1);
      $(this).find('.js-label-text').html('管理者のメールアドレス' + (index + 1) + '<span style="color: red"> *</span>');
    });
  }

  const $form = $('#admin_emails-nested-form');

  function getFocusableElements() {
    return $form.find(
      'input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'
    ).add($('.btn-save')).filter(':visible');
  }

  function moveCursorToEnd(el) {
    if (
      el &&
      (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') &&
      typeof el.setSelectionRange === 'function'
    ) {
      const len = el.value.length;
      el.focus();
      el.setSelectionRange(len, len);
    } else {
      el.focus();
    }
  }

  const firstInput = $form.find('.admin-email-item:visible').first().find('input[type="text"]');
  if (firstInput.length) {
    moveCursorToEnd(firstInput.get(0));
  }

  $(document).on('keydown', function (e) {
    if (e.key !== 'Tab') return;

    const focusable = getFocusableElements().toArray();
    const current = document.activeElement;
    const index = focusable.indexOf(current);

    if (index === -1) return;

    let nextIndex;
    if (e.shiftKey) {
      nextIndex = index === 0 ? focusable.length - 1 : index - 1;
    } else {
      nextIndex = index === focusable.length - 1 ? 0 : index + 1;
    }

    e.preventDefault();
    moveCursorToEnd(focusable[nextIndex]);
  });
});

function calculate_order_item_total_price() {
  var rows = $('#js-order-items-list-area .row.item');

  for (let i = 0; i < rows.length; i++) {
    var current_row = rows[i];
    var item_amount = $(current_row).find('.js-order-item-amount-col input.js-order-item-amount').val();
    var item_price = $(current_row).find('.js-product-price-col input.js-product-price').val();

    if (item_amount != "" && item_price != "") {
      item_amount = item_amount.replace(/,/g, '');
      item_price = item_price.replace(/,/g, '');
      var order_item_total_fee = parseFloat(item_price) * parseFloat(item_amount);
      order_item_total_fee = parseInt(order_item_total_fee);

      var display_order_item_total_fee = numberWithCommas(order_item_total_fee);
      $(current_row).find('.js-order-total-fee-col input.js-order-total-fee').val(display_order_item_total_fee);
    }
  }
}

function getAndStoreSearchedShops() {
  let query_string = location.search;

  $.ajax({
    url: '/shops/searched_shop_ids',
    method: 'GET',
    data: {
      query_string: query_string,
      'authenticity_token': $('meta[name="csrf-token"]').attr('content')
    }
  }).done(function (data) {
    let searched_shop_ids = data['shop_ids'];

    localStorage.setItem("checked_shop", searched_shop_ids.join(","));
  });
}

$(document).on('click', '.js-btn-export-shop-info', function (e) {
  e.preventDefault();

  let checked_shop = localStorage.getItem("checked_shop");

  let existed_setting_emails = $(this).data('existed-setting-emails');

  if (existed_setting_emails) {
    if (checked_shop) {
      let default_txt = `林製麺所のLINE注文方法をご説明いたします
ご注文までの流れ

① まずは、LINEアプリをダウンロードして登録してください
② 次に、QRコードをスキャンして、林製麺所公式アカウントの友達になりましょう
③ 店舗コードとパスワードを入力して、LINE注文システムにログインします

何かありましたらお気軽にご連絡ください`

      let textarea = $('.js-export-shop-info-modal').find('.free-text-content textarea');
      textarea.on('click', function (e) {
        e.stopImmediatePropagation();
      });    
      
      $('.js-export-shop-info-modal').find('.js-checked-shop-ids').val(checked_shop);
      $('.js-export-shop-info-modal').modal('show');
    } else {
      $('.js-not-select-shop-msg-modal').modal('show');
    }
  } else {
    $('label.js-label-notice-msg').html('マスターメニューのメールアドレス設定画面でメールを設定してください');
    $('.js-not-select-shop-msg-modal').modal('show');
  }
});

$(document).on('click', '.js-add-shop-products-btn', function (e) {
  e.preventDefault();

  update_added_product_ids_to_dom();

  $('.js-add-shop-products-modal').modal('show');
});

function update_added_product_ids_to_dom() {
  let items = $('#js-shop-products-table tbody#shop-products').find('tr.product-item:not([style*="display: none"])');
  let product_ids = [];

  for (let i = 0; i < items.length; i++) {
    let p_id = $(items[i]).data("item-id");
    if (p_id != null) {
      product_ids.push(p_id);
    }
  }

  $('.js-added-product-ids').val(product_ids);
}

$(document).on('click', '.js-append-shop-products-checked-btn', function (e) {
  e.preventDefault();

  let items = $('#js-search-results input[value="not_add"]:checked');

  for (let i = 0; i < items.length; i++) {
    $('#js-shop-products-table #js-link-to-add-item a').click();

    let item_row = $(items[i]).parents('tr.js-item-not-add');
    let product_id = $(item_row).data("item-id");
    let shop_product_items = $('#js-shop-products-table tbody#shop-products').find('tr.product-item');
    let inserted_item = shop_product_items[shop_product_items.length - 1];

    $(inserted_item).find('.js-product-id-col').val(product_id);
    $(inserted_item).find('td.js-exist-client-product-col').html($(item_row).find('td.js-exist-client-product-col').html());
    $(inserted_item).find('td.js-product-display-name-col').html($(item_row).find('td.js-product-display-name-col').html());
    $(inserted_item).find('td.js-product-code-col').html($(item_row).find('td.js-product-code-col').html());
    $(inserted_item).find('td.js-product-display-price-col').html($(item_row).find('td.js-product-display-price-col').html());

    $(inserted_item).data('item-id', product_id);

    $('.js-source-sale-users').select2({
      placeholder: "営業担当",
      language: { noResults: function () { return "見つかりません"; } }
    });
  }

  close_modal_add_shop_products();
});

$(document).on('click', '.js-close-modal-add-shop-products', function (e) {
  e.preventDefault();

  close_modal_add_shop_products();
});

function close_modal_add_shop_products() {
  $('.js-add-shop-products-modal').modal('hide');
  reset_shop_products_search_modal();

  $('.js-source-clients').select2({
    placeholder: "得意先名",
    language: { noResults: function () { return "見つかりません"; } }
  });
}

function reset_shop_products_search_modal() {
  $('.js-add-shop-products-modal input.input-field').val("");
  $('.js-add-shop-products-modal').find('#js-search-results table tbody').html("");
  $('.js-add-shop-products-modal').find('#js-search-results .paginate-row').html("");
}
